
const CodigosDeAreaPorPaises=[
        {codigoPais:591,pais: "Bolivia"},
        {codigoPais:51 ,pais: "Peru"},
        {codigoPais:52 ,pais: "Mexico"},
        {codigoPais:53 ,pais: "Cuba"},
        {codigoPais:54 ,pais: "Argentina"},
        {codigoPais:55 ,pais: "Brasil"},
        {codigoPais:56 ,pais: "Chile"},
        {codigoPais:57 ,pais: "Colombia"},
        {codigoPais:58 ,pais: "Venezuela"},
        {codigoPais:590,pais: "Guadalupe"},
        {codigoPais:592,pais: "Guyana"},
        {codigoPais:593,pais: "Ecuador"},
        {codigoPais:500,pais: "Islas Malvinas",},
        {codigoPais:501,pais: "Belice"},
        {codigoPais:502,pais: "Guatemala"},
        {codigoPais:503,pais: "El Salvador"},
        {codigoPais:504,pais: "Honduras"},
        {codigoPais:505,pais: "Nicaragua"},
        {codigoPais:506,pais: "Costa Rica"},
        {codigoPais:507,pais: "Panamá"},
        {codigoPais:508,pais: "San Pedro y Miquelón",},
        {codigoPais:509,pais: "Haiti"},
        {codigoPais:594,pais: "Guayana Francesa"},
        {codigoPais:595,pais: "Paraguay"},
        {codigoPais:596,pais: "Martinica"},
        {codigoPais:597,pais: "Surinam"},
        {codigoPais:598,pais: "Uruguay"},
        {codigoPais:809,pais: "República Dominicana"},
        {codigoPais:829,pais: "República Dominicana"},
        {codigoPais:849,pais: "República Dominicana"},
    ]

export default CodigosDeAreaPorPaises;